"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var getContainerElement = function getContainerElement(container) {
  var domNode = typeof container === 'function' ? container() : container; // eslint-disable-next-line react/no-find-dom-node

  return _reactDom["default"].findDOMNode(domNode);
};

var Portal = function Portal(_ref) {
  var container = _ref.container,
      children = _ref.children,
      onRender = _ref.onRender;

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      containerNode = _useState2[0],
      setContainerNode = _useState2[1];

  (0, _react.useEffect)(function () {
    setContainerNode(getContainerElement(container) || document.body);
  }, [container]);
  (0, _react.useEffect)(function () {
    if (onRender && containerNode) {
      onRender();
    }
  }, [onRender, containerNode]);
  return containerNode ? /*#__PURE__*/_reactDom["default"].createPortal(children, containerNode) : containerNode;
};

Portal.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]).isRequired,
  onRender: _propTypes["default"].func,
  container: _propTypes["default"].node
};
var _default = Portal;
exports["default"] = _default;